module.exports = __webpack_public_path__ + "img/c10.ff0f647a.svg";